import http from 'utilities/httpService';

export class JobTypeService {
  static async getJobTypes(limit) {
    return http.get(`/admin/job-types?_limit=${limit}`);
  }
}
